import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { Button, Modal } from "@h3/antd-vue";
import H3Textarea from "@cloudpivot/form/src/common/components/h3-textarea.vue";
import { AIPolishControl } from "./control";
let AIPolishPc = class AIPolishPc extends AIPolishControl {
    constructor() {
        super(...arguments);
        this.visible = false;
    }
    /** 获取当前控件允许输入的最大字符数。 */
    get maxLength() {
        return Number(this.controlOpts.maxLength) || 2000;
    }
    /** 将文本框直接编辑的内容写回当前表单数据项。 */
    onTextChange() {
        // 与移动端保持同一写回语义：清空时写 null。
        // applyPolishedText() 对空值直接 return，会导致"输入框已清空、表单数据项仍是旧值"，提交时保存旧文本。
        const value = this.polishedText;
        this.setValue(value.length === 0 ? null : value);
    }
    /** 打开 AI 润色弹窗并发起首次润色请求（结果写入弹窗草稿，不改动输入框）。 */
    openModal() {
        if (this.readonlyFormula || !this.validateSourceBeforeOpen()) {
            return;
        }
        this.visible = true;
        this.errorMessage = "";
        this.generate();
    }
    /** 关闭弹窗并丢弃未应用的润色草稿。 */
    closeModal() {
        if (!this.loading) {
            this.visible = false;
            this.dialogText = "";
        }
    }
    /** 基于当前润色结果（含用户手动调整）重新发起润色请求。 */
    repolish() {
        this.generate(this.dialogText);
    }
    /** 将润色结果草稿应用进表单输入框并关闭 AI 润色弹窗。 */
    apply() {
        this.polishedText = this.dialogText;
        this.applyPolishedText();
        this.visible = false;
    }
};
AIPolishPc = tslib_1.__decorate([
    Component({
        name: "AIPolishPc",
        components: {
            AButton: Button,
            AModal: Modal,
            H3Textarea,
        },
    })
], AIPolishPc);
export default AIPolishPc;
